<template>
  <div class="detail-container">
    <van-nav-bar :title="t('mensagens.details')" left-text="" left-arrow :border="false" class="custom-nav-bar"
      >
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="detail-content w-full" v-if="messageData">
      <!-- 标题 -->
      <div class="message-title" v-html="parsedTitle"></div>

      <!-- 图片（如果有） -->
      <div v-if="messageData.image" class="message-image-container">
        <img :src="messageData.image" alt="" class="message-img">
      </div>

      <!-- 内容 -->
      <div class="message-content" v-html="parsedContent"></div>
      <div class="flex items-center text-[11px] color-[#50B388] font-bold mt-[30px] justify-center justify-between">
        <div>📱&nbsp;{{ t('mensagens.telegram') }}</div>
        <div>📱&nbsp;{{ t('mensagens.facebook') }}</div>
        <div>📱&nbsp;{{ t('mensagens.whatsapp') }}</div>
        <div>📱&nbsp;{{ t('mensagens.onlineSupport') }}</div>
      </div>
      <div class="flex justify-between mt-[30px] text-[14px] color-[#50B388] font-bold">
        <div></div>
        <div>{{ t('mensagens.blueWhale') }}</div>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const route = useRoute()
const { t } = useI18n()

// 消息数据
const messageData = ref(null)

// 解析标题
const parsedTitle = computed(() => {
  if (!messageData.value?.title) return ''
  try {
    const titleObj = JSON.parse(messageData.value.title)
    return titleObj.en || titleObj.pt || titleObj.zh || ''
  } catch (e) {
    return messageData.value.title
  }
})

// 解析内容
const parsedContent = computed(() => {
  if (!messageData.value?.msg) return ''
  try {
    const msgObj = JSON.parse(messageData.value.msg)
    let content = msgObj.en || msgObj.pt || msgObj.zh || ''

    // 清理HTML中的内联样式
    content = content.replace(/style="[^"]*"/g, '') // 移除所有style属性
    content = content.replace(/width="[^"]*"/g, '') // 移除width属性
    content = content.replace(/height="[^"]*"/g, '') // 移除height属性

    return content
  } catch (e) {
    return messageData.value.msg
  }
})

const onClickLeft = () => {
  // 设置一个标记，表示从详情页返回
  sessionStorage.setItem('returnFromDetail', 'true')
  router.back()
}

// 获取消息详情
onMounted(() => {
  console.log('路由参数:', route?.query)

  // 从路由参数获取消息数据
  const messageFromList = route?.query?.message

  if (messageFromList) {
    try {
      messageData.value = JSON.parse(decodeURIComponent(messageFromList as string))
      console.log('解析后的消息数据:', messageData.value)
    } catch (e) {
      console.error('解析消息数据失败:', e)
    }
  }
})
</script>
<style lang="scss" scoped>
.detail-container {
  min-height: 100vh;
  color: #ffffff;
}

.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.detail-content {
  padding: 20px;
  text-align: center;
}

.message-title {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 20px;
  text-align: center;
  line-height: 1.4;
}

.message-image-container {
  margin: 20px 0;
  text-align: center;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.message-img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  display: block !important;
  border-radius: 8px;
  box-sizing: border-box;
}

.message-content {
  font-size: 15px;
  color: #50B388;
  line-height: 1.6;
  text-align: center;
  margin-top: 20px;
}

/* 重置富文本中的所有样式 */
.message-content * {
  max-width: 100% !important;
  box-sizing: border-box !important;
}

.message-content img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  display: block !important;
  border-radius: 8px;
  margin: 10px auto !important;
}

.message-content p {
  margin: 10px 0 !important;
  padding: 0 !important;
}

.message-content div {
  margin: 0 !important;
  padding: 0 !important;
}

.debug-info {
  padding: 20px;
  color: #ffffff;
  text-align: center;
}
</style>
<route lang="json5">
{
  "meta": {
    "title": "Details",
    "keepAlive": true
  }
}
</route>
